import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "14",
  viewBox: "0 0 20 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M0 6.33333C0 6.05719 0.223858 5.83333 0.5 5.83333H15.7444L12.0941 1.9898C11.9107 1.79664 11.9109 1.49356 12.0946 1.30065L12.9713 0.380172C13.1683 0.173276 13.4984 0.173276 13.6954 0.380172L20 7L13.6954 13.6198C13.4984 13.8267 13.1683 13.8267 12.9713 13.6198L12.0946 12.6993C11.9109 12.5064 11.9107 12.2034 12.0941 12.0102L15.7444 8.16667H0.5C0.223858 8.16667 0 7.94281 0 7.66667V6.33333Z",
  fill: "#2B3951"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };